module.exports = __webpack_public_path__ + "img/darkmode.f301f6ea.png";